module.exports = __webpack_public_path__ + "img/worktype-company.92a057b1.svg";